export const formattedCurrency = (amount, showCurrencyLast = true, options) => {
    const locale = (options === null || options === void 0 ? void 0 : options.locale) || window.theme.locale;
    const finalOptions = Object.assign({ style: 'currency', currency: window.theme.currency, currencyDisplay: 'narrowSymbol', compactDisplay: 'long' }, options);
    const amountFormatted = new Intl.NumberFormat(locale, Object.assign({}, finalOptions)).format(amount / 100);
    return `${amountFormatted}${showCurrencyLast ? ` ${finalOptions === null || finalOptions === void 0 ? void 0 : finalOptions.currency}` : ''}`;
};
export default formattedCurrency;
